import { defineComponent } from 'vue';
export default defineComponent({
    name: 'MessageBoxPlain',
    compatConfig: {
        MODE: 3,
    },
    props: {
        title: {
            type: String,
        },
        message: {
            type: String,
        },
        variant: {
            type: String,
            required: true,
            validator(value) {
                return ['info', 'warning', 'error', 'neutral'].includes(value);
            },
        },
    },
    watch: {
        message: {
            handler() {
                if (!this.message && !this.$slots.message) {
                    // eslint-disable-next-line fp/no-throw
                    throw new Error('Missing prop message or slot.');
                }
            },
            immediate: true,
        },
    },
});
